import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next"
import { Container, Row, Col, Card, OverlayTrigger, Tooltip, Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { CustomDataTable } from '../../../../components/design/Datatables/CustomDataTable'
import useAuth from '../../../../context/auth/useAuth'
import Loader from '../../../../components/design/Loader/Loader'
import { getTickets, getTicketsByClub, cancelAllActiveTicketsByClub } from '../../../../actions/ticketing/ticketsActions'
import TicketSummary from '../../../../components/ticketing/TicketSummary'
import ClubBreadCrumbs from '../../../../components/breadcrumbs/ClubBreadCrumbs'
import TicketingSubMenu from '../../../../components/menus/TicketingSubMenu'
import Swal from 'sweetalert2'
import WindowTicket from '../../../../components/ticketing/WindowTicket'
import { sendEmailDownloadEntry } from '../../../../actions/downloads/downloadsActions'
import * as XLSX from 'xlsx';

export default function Tickets({ usertype, isAdmin = false }) {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const { clientauth } = useAuth()

    const { tickets, loading, result, cancelAllCount } = useSelector(state => state.ticket)
    const { resultdownload } = useSelector(state => state.downloads)
    const { club } = useSelector(state => state.clubs)

    const [ticketSelected, setTicketSelected] = useState(null)
    const [formType, setFormType] = useState(null)

    const [addWindowTicket, setAddWindowTicket] = useState(false)

    const handleSendEmail = (e, ticketId) => {
        e.preventDefault()

        dispatch(sendEmailDownloadEntry(ticketId))
    }

    const exportToExcel = () => {
        if (!tickets || tickets.length === 0) return;

        const dataToExport = tickets.map(ticket => {
            // Calcular código del vale de canje solo si tiene cobro extra Y la entrada está activa (status === 1)
            const voucherCode = (ticket?.addon?.shirtSelected === true && ticket?.status === 1)
                ? (ticket?.identifier || '').slice(-8).toUpperCase()
                : ''

            return {
                [t('tickets.identifier')]: ticket?.identifier || '',
                [t('tickets.match')]: `${ticket.match?.host} - ${ticket.match?.visitor}`,
                [t('tickets.date')]: `${new Date(ticket.match?.date).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' })} ${ticket.match?.hour}`,
                [t('tickets.client')]: `${ticket.personData?.firstname || ''} ${ticket.personData?.lastname || ''}`,
                [t('tickets.sector')]: ticket.sector?.name || '',
                [t('tickets.price')]: ticket.price || 0,
                [t('tickets.status')]: ticket.status === 0 ? t('tickets.pending') :
                    ticket.status === 1 ? t('tickets.active') :
                        ticket.status === 2 ? t('tickets.canceled') :
                            t('tickets.unknown'),
                [t('tickets.email')]: ticket.personData?.email || '',
                [t('tickets.phone')]: ticket.personData?.phone || '',
                'Cobro Extra': voucherCode ? `${ticket?.addon?.shirtName || 'Cobro Extra'} (${voucherCode})` : '',
            }
        })

        const ws = XLSX.utils.json_to_sheet(dataToExport)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'Entradas')

        const fileName = `entradas_${club?.name}_${new Date().toISOString().split('T')[0]}.xlsx`
        XLSX.writeFile(wb, fileName)
    }

    const columnsTickets = [
        {
            name: t('tickets.identifier'),
            cell: ticket =>
                ticket.identifier,
            selector: (ticket) => ticket.identifier,
            sortable: true,
        },
        // {
        //     name: 'QR CODIGOOOOOO',
        //     width: "320px",
        //     cell: pass =>
        //         <div style={{width: '100%', height: '90vh', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        //             <QRCodeImage identifier={pass?.identifier} style={{width: '100%', height: '100%'}}/>
        //         </div>,
        //     selector: (pass) => pass.season.name,
        //     sortable: true,
        // },
        {
            name: t('tickets.match'),
            width: "200px",
            cell: ticket =>
                <div>
                    <div className='fw-bold'>{`${ticket.match.host} - ${ticket.match.visitor}`}</div>
                    <div><small>{`${new Date(ticket.match.date).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' })} ${ticket.match.hour}`}</small></div>
                </div>,
            selector: (ticket) => `${ticket.match.host} - ${ticket.match.visitor} ${new Date(ticket.match.date).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' })} ${ticket.match.hour}`,
            sortable: true,
        }, {
            name: t('tickets.sector'),
            cell: ticket =>
                ticket.sector.name,
            selector: (ticket) => ticket.sector.name,
            sortable: true,
        }, {
            name: t('tickets.status'),
            center: 'true',
            cell: ticket =>
                ticket.status === 0 ? t('tickets.pending') :
                    ticket.status === 1 ? t('tickets.active') :
                        ticket.status === 2 ? t('tickets.canceled') :
                            t('tickets.unknown'),
            selector: (ticket) =>
                ticket.status === 0 ? t('tickets.pending') :
                    ticket.status === 1 ? t('tickets.active') :
                        ticket.status === 2 ? t('tickets.canceled') :
                            t('tickets.unknown'),
            sortable: true,
        }, {
            name: t('tickets.price'),
            center: 'true',
            width: "100px",
            cell: ticket => (
                ticket.price !== null && ticket.price !== undefined
                    ?
                    <div>
                        {ticket.price} €
                    </div>
                    :
                    <></>
            ),
            selector: (ticket) => ticket.price,
            sortable: true,
        }, {
            name: t('tickets.client'),
            cell: ticket => (
                <div>
                    <span>{`${ticket.personData?.firstname} ${ticket.personData?.lastname || ''}`}</span>
                    {
                        ticket.pass
                            ?
                            <>
                                <br />
                                <small>{ticket.pass.passType?.name}</small>
                            </>
                            :
                            <></>
                    }
                </div>
            ),
            selector: (ticket) => `${ticket.personData?.firstname} ${ticket.personData?.lastname || ''} ${ticket.pass?.passType?.name || ''}`,
            sortable: true,
        },
        {
            name: t('global.actions'),
            center: 'true',
            width: '150px',
            cell: ticket =>
                <div className='d-flex w-100 justify-content-center align-items-center'>
                    <div
                        onClick={() => {
                            setTicketSelected(ticket)
                            setFormType("view")
                        }}
                        className='table-link me-2'>
                        <OverlayTrigger placement="top"
                            overlay={<Tooltip id="tooltip">{t('tickets.seeTicket')}</Tooltip>}
                        >
                            <img className="cursor" src="/images/eyeopen.svg" alt="eyes" height={16} />
                        </OverlayTrigger>
                    </div>
                    <div
                        onClick={(e) => {
                            handleSendEmail(e, ticket._id)
                        }}
                        className='table-link me-2'>
                        <OverlayTrigger placement="top"
                            overlay={<Tooltip id="tooltip">{t('tickets.sendemail')}</Tooltip>}
                        >
                            {/* <img src="/images/envelope.svg" alt="Email" className='me-2 my-2' /> */}
                            <i className='far fa-envelope'></i>
                        </OverlayTrigger>
                    </div>
                    <div className='table-link me-2'>
                        <a className='table-link' href={`/${t("url.marketplace.downloadticket")}/${ticket._id}/${ticket.identifier}`} rel='noopener noreferrer' target='_blank'>
                            <OverlayTrigger placement="top"
                                overlay={<Tooltip id="tooltip">{t('tickets.goToMarketplace')}</Tooltip>}
                            >
                                {/* <img className="cursor" src="/images/arrow-right.svg" alt="arrow" height={16}/> */}
                                <i className='fa-solid fa-download'></i>
                            </OverlayTrigger>
                        </a>
                    </div>
                    <div
                        onClick={() => {
                            setTicketSelected(ticket)
                            setFormType("edit")
                        }}
                        className='table-link'>
                        <OverlayTrigger placement="top"
                            overlay={<Tooltip id="tooltip">{t('tickets.editTicket')}</Tooltip>}
                        >
                            <img className="cursor" src="/images/pencil.svg" alt="pencil" height={16} />
                        </OverlayTrigger>
                    </div>
                </div>,
            sortable: false,
        }
    ]
    const ExpandedRow = ({ data }) => {
        return (
            <Container className='p-3'>
                <Row>
                    <Col xs={12} lg={6}>
                        <div className='d-flex justify-content-between border-1 border-bottom p-2'>
                            <small>{t('tickets.email')}</small> {data?.personData?.email}
                        </div>
                    </Col>
                    <Col xs={12} lg={6}>
                        <div className='d-flex justify-content-between border-1 border-bottom p-2'>
                            <small>{t('tickets.phone')}</small> {data?.personData?.phone}
                        </div>
                    </Col>
                </Row>
            </Container>
        )
    }

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'instant',
        })
        if (isAdmin) {
            dispatch(getTickets())
        } else {
            if (club) {
                dispatch(getTicketsByClub(club._id))
            }
        }
        // eslint-disable-next-line
    }, [dispatch, t, clientauth])

    useEffect(() => {
        if (result) {
            switch (result) {
                case 'changeStatusSuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'success',
                        text: t('tickets.changeStatusSuccess')
                    })
                    setTicketSelected(null)
                    setFormType(null)
                    dispatch(getTicketsByClub(club._id))
                    dispatch({ type: "TICKET_CHANGE_STATUS_RESET" })
                    break;
                case 'cancelAllActiveSuccess':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'success',
                        title: t('tickets.cancelAllActiveSuccessTitle'),
                        text: t('tickets.cancelAllActiveSuccessText', { count: cancelAllCount ?? 0 })
                    })
                    dispatch({ type: "TICKET_CHANGE_STATUS_RESET" })
                    if (isAdmin) {
                        dispatch(getTickets())
                    } else if (club) {
                        dispatch(getTicketsByClub(club._id))
                    }
                    break;
                default:
                    break;
            }
        }
    }, [result, cancelAllCount, club, dispatch, t, isAdmin])

    useEffect(() => {
        if (resultdownload) {
            switch (resultdownload) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'success',
                        text: t('passes.emailsendsuccess')
                    })
                    break;
                case 'notentryexist':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('passes.notentryexist')
                    })
                    break;
                case 'notemailexist':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'warning',
                        text: t('passes.notemailexist')
                    })
                    break;
                default:
                    break;
            }
            dispatch({ type: 'DOWNLOAD_RESET_RESULT' })
        }
    }, [resultdownload, t, dispatch])

    const handleCancelAllActive = () => {
        const activeCount = tickets?.filter(ticket => ticket.status === 1).length ?? 0
        Swal.fire({
            title: t('tickets.cancelAllActiveConfirmTitle'),
            html: t('tickets.cancelAllActiveConfirmText', { count: activeCount }),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6c757d',
            confirmButtonText: t('tickets.cancelAllActiveConfirmBtn'),
            cancelButtonText: t('global.cancel')
        }).then((swalResult) => {
            if (swalResult.isConfirmed && club) {
                dispatch(cancelAllActiveTicketsByClub(club._id, clientauth?.id))
            }
        })
    }

    return (
        <Container className='cuerpo'>
            {
                isAdmin
                    ?
                    <Row>
                        <Col className='d-flex align-items-center'>
                            <h1>{t('menus.ticketing.tickets')}</h1>
                        </Col>
                    </Row>
                    :
                    <>
                        <ClubBreadCrumbs usertype={usertype} club={club} />
                        <Row className="my-3">
                            <Col>
                                <TicketingSubMenu usertype={usertype} active="tickets" />
                            </Col>
                        </Row>
                    </>
            }
            <Row className='my-3'>
                <Col>
                    <Card>
                        <Card.Body>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h2>{t('tickets.ticketsList')}</h2>
                                <div>
                                    {tickets && tickets.length > 0 &&
                                        <Button variant="success" onClick={exportToExcel} className="me-2">
                                            <i className="fas fa-file-excel me-2"></i>
                                            {t('global.exportToExcel')}
                                        </Button>
                                    }
                                    {isAdmin && club && (
                                        <Button variant="danger" onClick={handleCancelAllActive} className="me-2">
                                            <i className="fas fa-ban me-2"></i>
                                            {t('tickets.cancelAllActive')}
                                        </Button>
                                    )}
                                    <Button variant="secondary" type="button" className='me-2' onClick={() => setAddWindowTicket(true)}>
                                        <i className='fas fa-plus' /> {t('tickets.addWindowTicket')}
                                    </Button>
                                </div>
                            </div>
                            <hr className='mb-4' />
                            <div className='my-3'>
                                <Row>
                                    <Col>
                                        {
                                            loading
                                                ?
                                                <Loader />
                                                :
                                                <>
                                                    {
                                                        tickets?.length > 0 ?
                                                            <CustomDataTable
                                                                columns={columnsTickets}
                                                                data={tickets}
                                                                exportable={false}
                                                                printable={false}
                                                                expandedData={ExpandedRow}
                                                            />
                                                            :
                                                            <div className='contenedor-vacio text-center'>
                                                                <h4>{t('tickets.noTickets')}</h4>
                                                                {t('tickets.thereIsNoTicketsPhrase')}
                                                            </div>
                                                    }
                                                </>
                                        }

                                    </Col>
                                </Row>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <TicketSummary ticketSelected={ticketSelected} closeModal={() => setTicketSelected(null)} formType={formType} usertype={usertype} />
            <WindowTicket userType="club" closeModal={() => { setAddWindowTicket(false) }} show={addWindowTicket} club={club} />
        </Container>
    )
}